/**
 * Returns the next chart height in the fixed height cycle
 * ([120, 150, 200, 250, 300]).
 *
 * "decrease" picks the largest height below `currentHeight`, clamping at the
 * minimum; "increase" picks the smallest height above it, clamping at the
 * maximum. Off-cycle values snap to the adjacent step.
 */
export const getNextChartHeight = (
  currentHeight: number,
  direction: "increase" | "decrease",
): number => {
  const validHeights = [120, 150, 200, 250, 300];

  if (direction === "decrease") {
    // Find the largest height that's smaller than current
    for (let i = validHeights.length - 1; i >= 0; i--) {
      if (validHeights[i] < currentHeight) {
        return validHeights[i];
      }
    }
    return validHeights[0]; // Return minimum if no smaller height found
  } else {
    // Find the smallest height that's larger than current
    for (let i = 0; i < validHeights.length; i++) {
      if (validHeights[i] > currentHeight) {
        return validHeights[i];
      }
    }
    return validHeights[validHeights.length - 1]; // Return maximum if no larger height found
  }
};
